"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageSelect = exports.Language = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const i18n_1 = require("@completeanatomy/i18n");
var Language;
(function (Language) {
    Language["English"] = "en";
    Language["Chinese"] = "zh";
    Language["Spanish"] = "es";
    Language["German"] = "de";
    Language["French"] = "fr";
})(Language || (exports.Language = Language = {}));
function LanguageSelect({ options, selected, onChange, className, }) {
    const [isDropdownOpened, setDropdownOpened] = (0, react_1.useState)(false);
    const dropdownRef = (0, react_1.useRef)(null);
    (0, ui_1.useOutsideClick)(dropdownRef, () => onItemClick(selected));
    const handleDropdownBlurEvent = (event) => {
        const currentTarget = event.currentTarget;
        /**
         * Give browser time to focus the next element
         */
        requestAnimationFrame(() => {
            /**
             * Check if the new focused element is a child of the original container
             */
            if (!currentTarget.contains(document.activeElement)) {
                setDropdownOpened(false);
            }
        });
    };
    const onInputClick = () => {
        setDropdownOpened(prevState => !prevState);
    };
    const onItemClick = (clickedOption) => {
        onChange(clickedOption);
        setDropdownOpened(false);
    };
    const dropdownItems = options.map(option => {
        return ((0, jsx_runtime_1.jsx)(Item, { onClick: () => onItemClick(option), "$selected": selected.locale === option.locale, role: "option", "data-e2e": 'LanguageSelect_Item', children: (0, i18n_1.Localized)(option.name) }, option.locale));
    });
    return ((0, jsx_runtime_1.jsxs)(Container, { className: className, "data-e2e": 'LanguageSelect_Container', children: [(0, jsx_runtime_1.jsxs)(Input, { onClick: onInputClick, "$opened": isDropdownOpened, "data-e2e": 'LanguageSelect_Input', children: [(0, i18n_1.Localized)(selected.name), (0, jsx_runtime_1.jsx)(ui_1.Icon, { name: ui_1.Icons.Arrow_Down, width: 10, height: 10, "data-e2e": 'LanguageSelect_Icon' })] }), (0, jsx_runtime_1.jsx)(Dropdown, { ref: dropdownRef, "$opened": isDropdownOpened, onBlur: handleDropdownBlurEvent, role: "listbox", "data-e2e": 'LanguageSelect_Dropdown', children: dropdownItems })] }));
}
exports.LanguageSelect = LanguageSelect;
const Container = styled_components_1.default.div `
  position: relative;

  width: 100%;
`;
const Input = (0, ui_1.withA11y)(styled_components_1.default.button `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  margin: 0;
  padding: 8px 0;

  color: ${({ theme }) => theme.text};
  font-size: 14px;
  line-height: 20px;
  text-align: left;

  background: transparent;
  border: none;
  border-bottom: 1px solid
    ${({ theme, $opened }) => $opened
    ? theme.designSystem.accent
    : theme.designSystem.highlightedBorder};

  cursor: pointer;
`);
const Dropdown = styled_components_1.default.div `
  position: absolute;
  z-index: 1;

  display: flex;
  flex-direction: column;

  width: 100%;

  visibility: ${({ $opened }) => ($opened ? 'visible' : 'collapse')};
`;
const Item = (0, ui_1.withA11y)(styled_components_1.default.button `
  position: relative;

  width: 100%;
  margin: 0;
  padding: 12px 16px 13px;

  color: ${({ theme }) => theme.designSystem.text};
  font-weight: ${({ $selected }) => ($selected ? '600' : '400')};
  font-size: 14px;
  line-height: 20px;
  text-align: left;

  background: ${({ theme }) => theme.designSystem.highlightedBackground};
  border: none;
  outline-offset: -2px;
  cursor: pointer;

  &:after {
    position: absolute;
    right: 16px;
    bottom: 0;
    left: 16px;

    display: block;
    height: 1px;

    background: ${({ theme }) => theme.designSystem.highlightedBorder};
    opacity: 0.5;

    content: '';
  }

  &:last-child:after {
    display: none;
  }

  &:last-child {
    padding-bottom: 12px;
  }
`);
